import { memo } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, useTheme } from '@material-ui/core';

const AnnotationIcon = ({ height, width }) => {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89138 2.75 2.75 6.89137 2.75 12V21.25H12C17.1087 21.25 21.25 17.1086 21.25 12C21.25 6.89136 17.1087 2.75 12 2.75ZM2 22L1.25 21.9999V12C1.25 6.06293 6.06296 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75H2.00008L2 22ZM2 22L2.00008 22.75C1.58587 22.75 1.25 22.4141 1.25 21.9999L2 22Z"
        fill={theme.palette.secondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12Z"
        fill={theme.palette.secondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5L12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5L11.25 7.5C11.25 7.08579 11.5858 6.75 12 6.75Z"
        fill={theme.palette.secondary}
      />
    </SvgIcon>
  );
};

AnnotationIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

AnnotationIcon.defaultProps = {
  height: 24,
  width: 24,
};

export default memo(AnnotationIcon);
